import { Observable } from 'rxjs';

import { Response } from '@shure/shared/angular/data-access/system-api/models';

import { CompressorChannel } from '../models';

export abstract class CompressorApiService {
	/**
	 * Get channel that supports compressor.
	 */
	public abstract getChannel$(channelId: string): Observable<CompressorChannel>;

	/**
	 * Enable/disable compressor for channel.
	 */
	public abstract toggleCompressor(channelId: string, enabled: boolean): Observable<Response<void, string>>;

	public abstract setThreshold(channelId: string, threshold: number): Observable<Response<void, string>>;

	public abstract setRatio(channelId: string, ratio: number): Observable<Response<void, string>>;
}
